<template>
  <div class="picture">
    <img :src="require(`@/assets/images/${image}`)" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: 'default.png',
    },
  },
}
</script>

<style lang="scss" scoped>
.picture {
  max-width: 2560px;
  margin-inline: auto;
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
